// extracted by mini-css-extract-plugin
export var backdrop = "_dw-1";
export var dragging = "_dw-4";
export var handle = "_dw-6";
export var handleHit = "_dw-5";
export var listEnd = "_dw-8";
export var modalRoot = "_dw-0";
export var sectionHeader = "_dw-a";
export var sheet = "_dw-3";
export var sheetHost = "_dw-2";
export var shortcutColumns = "_dw-7";
export var shortcutSection = "_dw-9";